var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressSuccessDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "progressSuccessDisabledTitle"
  }, "Progress success disabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "progressSuccessDisabledTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z M15,2 C7.82029825,2 2,7.82029825 2,15 C2,22.1797017 7.82029825,28 15,28 C22.1797017,28 28,22.1797017 28,15 C28,7.82029825 22.1797017,2 15,2 Z M20.650164,11.2402061 C21.0375079,11.5716605 21.1091258,12.135035 20.8354293,12.5497913 L20.7597939,12.650164 L14.7698176,19.650164 C14.4046222,20.0769383 13.7679698,20.1142475 13.3558474,19.7565471 L13.2649537,19.6669863 L10.25493,16.3045809 C9.88656366,15.8930901 9.92152292,15.260891 10.3330137,14.8925246 C10.7128514,14.5524941 11.2807482,14.5561257 11.6555995,14.8823451 L11.74507,14.9706083 L13.993,17.481 L19.2402061,11.349836 C19.5992817,10.9302134 20.2305413,10.8811304 20.650164,11.2402061 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressSuccessDisabled);
export default __webpack_public_path__ + "static/media/progress-success-disabled.abcbc9702938e618ca710584096ae938.svg";
export { ForwardRef as ReactComponent };